import { motion } from "framer-motion";

// Facts verified via Blackstone Library / Barnes & Noble listings.
const AudiobookSection = () => (
  <section data-testid="audiobook-section" className="relative mx-auto w-full max-w-6xl px-6 pb-32 md:px-10">
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1, ease: "easeOut" }}
      className="relative overflow-hidden border border-[#8a6a1f]/30 bg-[#fffdf7] px-6 py-14 md:px-16 md:py-20"
      style={{ boxShadow: "0 30px 60px rgba(94,63,14,0.12), inset 0 0 0 6px #fffdf7, inset 0 0 0 7px rgba(138,106,31,0.15)" }}
    >
      <div className="flex flex-col items-center gap-10 md:flex-row md:gap-16">
        <img
          src="/books/hidden-women.jpg"
          alt="Hidden Women — audiobook cover"
          className="w-48 shrink-0 md:w-64"
          style={{ boxShadow: "0 20px 50px rgba(94,63,14,0.25)" }}
          data-testid="audiobook-cover"
        />
        <div className="flex flex-col items-center gap-5 text-center md:items-start md:text-left">
          <span className="text-[10px] uppercase text-[#8a6a1f]" style={{ letterSpacing: "0.4em" }}>
            the audiobook
          </span>
          <h2 className="font-serif-display text-3xl font-light leading-tight text-[#211d15] md:text-5xl">
            Hidden Women
          </h2>
          <p className="font-serif-display text-sm italic text-[#7a7160]">
            Dara's Tree &amp; Cosmic and Eternal Love
          </p>
          <p className="font-serif-display max-w-xl text-lg font-light leading-relaxed text-[#211d15]/70 md:text-xl">
            The untold stories of the women behind famous men — written and
            narrated by Amrita, with her original music woven through. With
            additional writing by Jake Stark. Myst Music, 2023 &middot; 1 hr
            43 min.
          </p>
          <div className="mt-2 flex flex-wrap items-center justify-center gap-4 md:justify-start">
            <a
              data-testid="audiobook-kobo-link"
              href="https://www.kobo.com/us/en/audiobook/hidden-women-1"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-[#8a6a1f]/40 px-6 py-3 text-xs uppercase text-[#8a6a1f] transition-all duration-500 hover:bg-[#8a6a1f] hover:text-[#f6f1e5]"
              style={{ letterSpacing: "0.3em" }}
            >
              Kobo
            </a>
            <a
              data-testid="audiobook-libro-link"
              href="https://libro.fm/audiobooks/9798212617154-hidden-women"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-[#8a6a1f]/40 px-6 py-3 text-xs uppercase text-[#8a6a1f] transition-all duration-500 hover:bg-[#8a6a1f] hover:text-[#f6f1e5]"
              style={{ letterSpacing: "0.3em" }}
            >
              Libro.fm
            </a>
            <a
              data-testid="audiobook-bn-link"
              href="https://www.barnesandnoble.com/w/hidden-women-amrita-sen/1143612562"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-[#8a6a1f]/40 px-6 py-3 text-xs uppercase text-[#8a6a1f] transition-all duration-500 hover:bg-[#8a6a1f] hover:text-[#f6f1e5]"
              style={{ letterSpacing: "0.3em" }}
            >
              Barnes &amp; Noble
            </a>
          </div>
        </div>
      </div>
    </motion.div>
  </section>
);

export default AudiobookSection;
